import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=f12ee8bc&scoped=true"
import script from "./TemplatesList.vue?vue&type=script&lang=js"
export * from "./TemplatesList.vue?vue&type=script&lang=js"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=f12ee8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12ee8bc",
  null
  
)

export default component.exports